import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Tracks from '../containers/Tracks.js'

export default class Playlists extends Component {
  render () {
    const {
      debug,
      className,
      playlist,
      playlists,
      onLoadTracks,
      onSetPlayback,
      playback
    } = this.props

    const items = playlists && playlists.map((item, i) =>
      <div
        key={i}
        className={playlist === i ? 'playlist-container current' : 'playlist-container'}
        onClick={() => {
          if (playlist !== i) {
            onLoadTracks(item.uid)
            if (playback !== 1) {
              onSetPlayback(1)
            }
          }
        }}>
        <div className="cover" style={{backgroundImage: `url(${item.cover})`}}>
        </div>
        <div className="text">
          <strong className={playlist === i ? 'value active' : 'value'}>
            {item.artist ? item.artist + '—' : '' }{item.title}{debug ? ' (uid: ' + item.uid + ')' : ''}
          </strong>
          {item.link &&
            <span className='playlist-link'>
              <a href={item.link} alt='artist link' target='_blank' rel="noopener noreferrer">Link ↗</a>
            </span>
          }
        </div>
      </div>
    )

    return (
      <div className={'playlists ' + className}>
        <div className='playlists-container'>
          { debug &&
            <h3>Playlists.jsx</h3>
          }
          {items}
        </div>
        <Tracks debug={debug} />
      </div>
    )
  }
}

Playlists.defaultProps = {
  debug: false,
  className: '',
  mini: true
}

Playlists.propTypes = {
  mini: PropTypes.bool,
  debug: PropTypes.bool,
  className: PropTypes.string,
  playlist: PropTypes.number,
  playlists: PropTypes.array,
  onLoadTracks: PropTypes.func,
  onSetPlayback: PropTypes.func,
  playback: PropTypes.number
}
